import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import type { StationOut } from "./api";

type Props = {
  candidates: StationOut[];
  onCancel: () => void;
};

export function DedupeCandidates({ candidates, onCancel }: Props) {
  const { t } = useTranslation();
  return (
    <section
      role="alert"
      className="space-y-3 rounded-md border border-ember/30 bg-ember/5 p-4"
    >
      <div>
        <h2 className="text-sm font-semibold text-ember">{t("stations.duplicates_title")}</h2>
        <p className="mt-1 text-xs text-ember">{t("stations.duplicates_body")}</p>
      </div>
      <ul className="space-y-2">
        {candidates.map((c) => (
          <li key={c.id}>
            <Link
              to={`/stations/${c.id}`}
              className="block rounded-md border border-line bg-surface p-2 text-sm hover:border-line-strong"
            >
              <p className="font-medium text-fg">{c.name}</p>
              {c.address && <p className="text-xs text-fg-mute">{c.address}</p>}
            </Link>
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={onCancel}
        className="text-xs font-medium text-fg-mute underline"
      >
        {t("common.cancel")}
      </button>
    </section>
  );
}
